import React, { FC } from 'react';

export const Page: FC = () => {
    return (
        <h1>Whoops</h1>
    )
}